<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import jwt from "@/http/requests/auth/jwt/index.js";
import axios from "axios";

export default {
  data() {
    return {
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    axios.defaults.headers.common["Authorization"] =
      "Bearer " + this.$store.getters["auth/token"];

    axios.interceptors.response.use(
      (response) => {
        if (response.data.version) {
          const storedVersion = localStorage.getItem("version", "");
          if (response.data.version !== storedVersion) {
            localStorage.clear();
            localStorage.setItem("version", response.data.version);
            // Perform logout action here
            // For example, you can redirect to the login page
            window.location.href = "/pages/login";
          }
        }
        return response;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  },
  async created() {
    // jwt
    jwt.init();

    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);

    // Auth0
    try {
      await this.$auth.renewTokens();
    } catch (e) {
      console.error(e);
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="css">
@import "https://pagos.stadiumcasablanca.com/css/appNueva.css";

.hijos .hijo {
  background: #39863d !important;
  border: none !important;
  color: white;
}
.hijos h4 {
  color: white;
}
.loading .effect-1,
.loading .effect-2 {
  border-left: 3px solid #39863d;
}
.loading .effect-3 {
  border-left: 3px solid #39863d;
}
.vs-input--label {
  font-size: 16px;
}
.vs-input--input.normal {
  font-size: 15px;
}
.vs-con-input {
  margin-bottom: 10px;
}
.header-sidebar > div:nth-child(2) {
  margin-bottom: 50px;
}
</style>
